import { ProductInfoMessageDataRequest } from '@entities/product/api/product-types';
import { IHintProps } from '@vtbhome/juicyfront/components/atoms/Hint/Hint';

export const MESSAGE_ORDER_STATUS_MAP: Record<string, ProductInfoMessageDataRequest['messageType']> = {
    completed: 'success',
    order_reject: 'fail',
};

export const HINT_STATUS_MAP: Record<string, IHintProps['variant']> = {
    completed: 'green',
    order_reject: 'red',
};
